export default __webpack_public_path__ + "static/media/send_filled_white.9e10bd55.svg";